import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function() {
    'use strict';

    angular.module('app').component('rating', {
        template: require('./rating-module.html'),
        controller: RatingModuleCtrl,
        controllerAs: 'vm'
    });

    RatingModuleCtrl.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        '$location',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function RatingModuleCtrl(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        $location,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {

        var vm = this;
        vm.otherBackground = require('Images/project_dino_a_1024.png');
        vm.isPassword = false;
        vm.logo = require('Images/nav-logo.png');

        vm.id = $stateParams.id;

        vm.ratings = [{
            display_name: '발음이 깔끔했다',
            name: 'pronunciation',
        },{
            display_name: '선생님께서 시간을 엄수했다',
            name: 'punctuality',
        },{
            display_name: '선생님께서 성실하셨다',
            name: 'faith',
        },{
            display_name: '선생님께서 똑똑하셨다',
            name: 'smartness',
        },{
            display_name: '수업 피드백이 도움이 되었다/될 것 같다',
            name: 'helpfulness',
        }];

        vm.scores = [{
            display_name: '매우 그렇다',
            value: 5
        },{
            display_name: '그렇다',
            value: 4
        },{
            display_name: '보통이다',
            value: 3
        },{
            display_name: '그렇지 않다',
            value: 2
        },{
            display_name: '매우 그렇지 않다',
            value: 1
        },];

        vm.data = {
            will_enroll: 'yes',
        };
        vm.save = function(){
            vm.data.regular_class_id = $stateParams.id;

            var request = {
                method: 'POST',
                route: URLS.base + `/rating`,
                body:vm.data
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        vm.has_rating = true;
                        vm.get_data();
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });

        }

        vm.get_data = function(){

            var request = {
                method: 'GET',
                route: URLS.base + `/rating/`+$stateParams.id,
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        if(response.data.data.items.length){
                            vm.has_rating = true;
                        }else{
                            vm.has_rating = false;
                        }
                        console.log(vm.has_rating);
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });

        }
        vm.get_data();
        
        vm.goHomeYoureDrunk = () => {
            $location.path('home-page');
        };

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/rating-module/rating-module.component.js